export const Pending = "pend";
export const Resolved = "resolve";
export const Ineligible = "ineligible";
export const Hidden = "hide";
export const Unhidden = "unhide";
export const Eligible = "eligible";
